import React from "react";
import { Link } from "react-router-dom";
import { User, Download, BadgeDollarSign, Globe } from "lucide-react";
import { Logo } from "./Logo";
import { BRAND } from "../config/brand";
import { AreaWebButton } from "./AreaWebModal";

export default function Header() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-ink/80 border-b border-white/5">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 shrink-0">
          <a href="/" className="flex items-center shrink-0" data-testid="header-logo-link">
            <Logo variant="horizontal" className="h-8 sm:h-11 max-w-none" testId="header-logo" />
          </a>
        </div>

        <div className="flex items-center gap-1.5 sm:gap-2 md:gap-4 min-w-0">
          <Link
            to="/revenda"
            data-testid="nav-revenda-link"
            aria-label="Revenda"
            className="inline-flex items-center gap-2 p-2 sm:px-4 rounded-full bg-brand-3/10 hover:bg-brand-3/20 border border-brand-3/40 text-brand-3 text-sm font-semibold transition-colors"
          >
            <BadgeDollarSign className="w-4 h-4" />
            <span className="hidden sm:inline">Revenda</span>
          </Link>

          <Link
            to="/baixar"
            data-testid="header-baixar-link"
            className="inline-flex items-center gap-2 p-2 sm:px-4 rounded-full bg-brand-2/15 hover:bg-brand-2/25 border border-brand-2/40 text-brand-2 text-sm font-semibold transition"
          >
            <Download className="w-4 h-4" />
            <span className="hidden md:inline">Baixar App</span>
          </Link>

          <AreaWebButton
            testId="area-web-btn"
            className="inline-flex items-center gap-2 p-2 sm:px-4 rounded-full bg-brand-gradient hover:brightness-110 text-white text-sm font-semibold shadow-lg shadow-brand-2/30 transition"
          >
            <Globe className="w-4 h-4 sm:hidden" />
            <span className="hidden sm:inline">Área Web</span>
          </AreaWebButton>

          <a
            href={BRAND.links.subscriberPortal}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-login-btn"
            title="Área do Assinante"
            aria-label="Área do Assinante"
            className="inline-flex items-center gap-2 p-2 lg:px-4 rounded-full border border-white/15 hover:bg-white/5 transition-colors"
          >
            <User className="w-4 h-4 text-white/90" />
            <span className="hidden lg:inline text-sm text-white/90 font-semibold">Área do Assinante</span>
          </a>
        </div>
      </div>
    </header>
  );
}
